export const reportTypeDropDownOptions = [
    {value: 'Environments Report', label: 'Environments Report'},
    {value: 'Intelligence Report', label: 'Intelligence Report'},
    {value: 'ThreatGuard Report', label: 'ThreatGuard Report'}
]
